/**
 * Cognito group helpers.
 *
 * `user` is the decoded id token payload from UserContext (App.jsx), whose
 * groups live in user["cognito:groups"]. Prefer these helpers over inline
 * `includes("Admin")` checks: most admin features are open to Moderators as
 * well (see the isAdmin logic in App.jsx).
 */

export function hasGroup(user, group) {
  const groups = user?.["cognito:groups"];
  return Array.isArray(groups) && groups.includes(group);
}

export function isAdminOrModerator(user) {
  return hasGroup(user, "Admin") || hasGroup(user, "Moderator");
}
